import { createRouter, createWebHistory } from 'vue-router';
import {
  getAssignedSucursales,
  getCurrentSucursalIdFromSession,
  hasAnyPermission,
  hasPermission,
  hasAuthToken,
  setCurrentSucursalId
} from '@/services/authSessionService';
import { homeDestino } from './homeDestino.mjs';
import ClientesView from '../views/ClientesView.vue'; // Importa la vista de Clientes
import PantallaInicio from '../views/PantallaInicio.vue'; 
import LoginView from '../views/LoginView.vue';
import FirstAccessView from '../views/FirstAccessView.vue';
import FacturaView from '../views/Factura.vue'; // Importa la pantalla de Factura
import NotaDeRemision from '../views/NotaDeRemision.vue'; // Importa la pantalla de NotaDeRemision
import ListarComprobantes from '../views/ListarComprobantes.vue'; // Importa la pantalla de ListarComprobantes
import GestionPedidos from '../views/GestionPedidos.vue';
import EPedidosView from '../views/EPedidosView.vue';
import UserManagement from '../views/UserManagement.vue'; // Importa UserManagement
import RegistrarProveedor from '@/components/RegistrarProveedorModal.vue';
import RegistrarProductoModal from '@/components/RegistrarProductoModal.vue';
import ProductosPrecioView from '@/views/Inventario/ProductosPrecioView.vue'; // Importa la pantalla de Productos
import ProveedoresView from '@/views/ProveedoresView.vue';
import PermisosView from '@/views/PermisosView.vue';
import ListarComprobantesNT from '@/views/ListarComprobantesNT.vue';
import RolesView from '@/views/RolesView.vue';
import SuscripcionesView from '@/views/Cobranza/SuscripcionesView.vue';
import SuscripcionAltaView from '@/views/Cobranza/SuscripcionAltaView.vue';
import SuscripcionDetalleView from '@/views/Cobranza/SuscripcionDetalleView.vue';
import EsquemasView from '@/views/Cobranza/EsquemasView.vue';
import EsquemaDetalleView from '@/views/Cobranza/EsquemaDetalleView.vue';
import GeneracionView from '@/views/Cobranza/GeneracionView.vue';
import CargosEventualesView from '@/views/Cobranza/CargosEventualesView.vue';
import CobroView from '@/views/Cobranza/CobroView.vue';
import InscripcionLoteView from '@/views/Cobranza/InscripcionLoteView.vue';
import CobrosView from '@/views/Cobranza/CobrosView.vue';
import EstadoCuentaView from '@/views/Cobranza/EstadoCuentaView.vue';
import VentasDiferidasView from '@/views/Cobranza/VentasDiferidasView.vue';
import CajaView from '@/views/CajaView.vue'; // Importa la pantalla de Caja
import CerrarCajaView from '@/views/CerrarCajaView.vue'
import CobroFacturaVentaView from '@/views/CobroFacturaVentaView.vue';
import CobroVentaRapidaView from '@/views/CobroVentaRapidaView.vue';
import IngresoVariosView from '@/views/IngresoVariosView.vue';
import EgresoVariosView from '@/views/EgresoVariosView.vue';
import MovimientosCajaView from '@/views/MovimientosCajaView.vue';
import CobroClienteCredito from '@/views/CobroClienteCredito.vue';
import PagoFactura from '@/views/PagoFactura.vue';
import InventoryLayout from '@/views/InventoryLayout.vue';
import MaintenanceLayout from '@/views/Mantenimiento/MaintenanceLayout.vue';
import DashboardView   from '@/views/Inventario/DashboardView.vue'
import ProductosView from '@/views/Inventario/ProductosView.vue';
import ImportacionProductosView from '@/views/Inventario/ImportacionProductosView.vue';
import PresentacionesView from '@/views/Inventario/PresentacionesView.vue';
import GruposPrecioView from '@/views/Inventario/GruposPrecioView.vue';
import MovimientosView from '@/views/Inventario/MovimientosView.vue';
import LotesView from '@/views/Inventario/LotesView.vue';
import ControlInventarioView from '@/views/Inventario/ControlInventarioView.vue';
import DepositosView from '@/views/Inventario/DepositosView.vue';
import MantenimientoOperativoView from '@/views/Inventario/MantenimientoOperativoView.vue';
import MantenimientoHomeView from '@/views/Mantenimiento/MantenimientoHomeView.vue';
import MantenimientoBalanzasView from '@/views/Mantenimiento/MantenimientoBalanzasView.vue';
import MantenimientoFiscalDashboardView from '@/views/Mantenimiento/MantenimientoFiscalDashboardView.vue';
import MantenimientoFiscalEstablecimientosView from '@/views/Mantenimiento/MantenimientoFiscalEstablecimientosView.vue';
import MantenimientoFiscalPuntosView from '@/views/Mantenimiento/MantenimientoFiscalPuntosView.vue';
import MantenimientoFiscalTimbradosView from '@/views/Mantenimiento/MantenimientoFiscalTimbradosView.vue';
import MantenimientoFiscalSeriesView from '@/views/Mantenimiento/MantenimientoFiscalSeriesView.vue';
import MantenimientoFiscalFacturacionView from '@/views/Mantenimiento/MantenimientoFiscalFacturacionView.vue';
import MantenimientoCajasView from '@/views/Mantenimiento/MantenimientoCajasView.vue';
import MantenimientoJobsView from '@/views/Mantenimiento/MantenimientoJobsView.vue';
// Sección Ecommerce propia (RF-2 de SPEC_SUITE_BASE_COMERCIO_v0.1.md).
// Las vistas de configuración e imágenes se movieron acá desde Mantenimiento.
import EcommerceLayout from '@/views/Ecommerce/EcommerceLayout.vue';
import EcommerceHomeView from '@/views/Ecommerce/EcommerceHomeView.vue';
import EcommerceConfiguracionView from '@/views/Ecommerce/EcommerceConfiguracionView.vue';
import EcommerceMensajesView from '@/views/Ecommerce/EcommerceMensajesView.vue';
import EcommerceImagenesView from '@/views/Ecommerce/EcommerceImagenesView.vue';
import ReportesLayout from '@/views/Reportes/ReportesLayout.vue';
import ReportesHomeView from '@/views/Reportes/ReportesHomeView.vue';
import ReportesIngresosView from '@/views/Reportes/IngresosView.vue';
import ReportesVentasView from '@/views/Reportes/VentasView.vue';
import ReportesCierresCajaView from '@/views/Reportes/CierresCajaView.vue';
import ReportesProductosVendidosView from '@/views/Reportes/ProductosVendidosView.vue';
import ReportesCreditosClientesView from '@/views/Reportes/CreditosClientesView.vue';
import ReportesMorosidadView from '@/views/Reportes/MorosidadView.vue';
import ReportesCobranzaPeriodoView from '@/views/Reportes/CobranzaPeriodoView.vue';
import ReportesDeudaPorResponsableView from '@/views/Reportes/DeudaPorResponsableView.vue';
import ReportesUtilidadView from '@/views/Reportes/UtilidadView.vue';
import ReportesComprasProveedorView from '@/views/Reportes/ComprasProveedorView.vue';
import GerencialDashboardView from '@/views/DashboardView.vue';
import CategoriaView from '@/views/Inventario/CategoriaView.vue';
import UnidadMedidaView from '@/views/Inventario/UnidadMedidaView.vue';
import VentasFacturasView from '@/views/VentasFacturasView.vue';
import NotasCreditoView from '@/views/NotasCreditoView.vue';
import { checkForUpdate, isChunkLoadError } from '@/services/appVersionService';
// Vista de impresión (carga perezosa)
const FacturaPrint = () => import('@/views/FacturaPrint.vue');
const ClientesCreditoView = () => import('@/views/ClientesCredito/ClientesCreditoView.vue');
const ClienteCreditoAsignarView = () => import('@/views/ClientesCredito/ClienteCreditoAsignarView.vue');
const ClienteCreditoDetalleView = () => import('@/views/ClientesCredito/ClienteCreditoDetalleView.vue');
const ClienteCreditoCrearView = () => import('@/views/ClientesCredito/ClienteCreditoCrearView.vue');

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/first-access',
    name: 'FirstAccess',
    component: FirstAccessView
  },
  {
    path: '/registrar-proveedor',
    name: 'RegistrarProveedor',
    component: RegistrarProveedor,
    meta: { requiresAuth: true, permissions: ['crear_proveedor'] }
  },
  // ---------------------------------------------------------------------
  // Módulo SUSCRIPCIONES — el backoffice: QUÉ se cobra (D23, SPEC 3.1)
  //
  // El corte entre este bloque y el de Cobranza es el de los actores, no el
  // de las entidades: acá vive lo que configura el ADMINISTRADOR, abajo lo
  // que opera el CAJERO. Antes todo colgaba de `/cobranza`, y eso chocaba
  // con la cobranza que el operador ya tenía en caja — con el agravante de
  // que "cobranza" contenía esquemas y generación, que no son cobranza.
  //
  // Las rutas literales van ANTES de `/suscripciones/:id`: vue-router toma
  // la primera que coincide, y `:id` se comería `nueva`, `lote`, `esquemas`
  // y `generacion`. Es el mismo orden que ya usaba el bloque anterior.
  {
    // `ver_suscripciones` lo tiene también `caja`: el cajero necesita
    // encontrar la suscripción para cobrarla, pero el alta y la edición
    // piden `administrar_suscripciones`.
    path: '/suscripciones',
    name: 'Suscripciones',
    component: SuscripcionesView,
    meta: { requiresAuth: true, permissions: ['ver_suscripciones'] }
  },
  {
    path: '/suscripciones/nueva',
    name: 'SuscripcionAlta',
    component: SuscripcionAltaView,
    meta: { requiresAuth: true, permissions: ['administrar_suscripciones'] }
  },
  {
    path: '/suscripciones/lote',
    name: 'SuscripcionLote',
    component: InscripcionLoteView,
    meta: { requiresAuth: true, permissions: ['administrar_suscripciones'] }
  },
  // Los esquemas y la generación NO son del cajero: configurar el cobro y
  // crear la deuda de cientos de personas piden sus propios permisos.
  {
    path: '/suscripciones/esquemas',
    name: 'Esquemas',
    component: EsquemasView,
    meta: { requiresAuth: true, permissions: ['ver_esquemas_cobro'] }
  },
  {
    path: '/suscripciones/esquemas/:id',
    name: 'EsquemaDetalle',
    component: EsquemaDetalleView,
    meta: { requiresAuth: true, permissions: ['ver_esquemas_cobro'] }
  },
  {
    path: '/suscripciones/generacion',
    name: 'Generacion',
    component: GeneracionView,
    meta: { requiresAuth: true, permissions: ['generar_deudas'] }
  },
  // Cargo eventual (D38). Permiso PROPIO: es lo único del módulo que el
  // `gerente` puede hacer, y no le abre el calendario ni la generación masiva.
  {
    path: '/suscripciones/cargos',
    name: 'CargosEventuales',
    component: CargosEventualesView,
    meta: { requiresAuth: true, permissions: ['administrar_cargos_eventuales'] }
  },
  {
    // Última del bloque: `:id` coincide con cualquier cosa.
    path: '/suscripciones/:id',
    name: 'SuscripcionDetalle',
    component: SuscripcionDetalleView,
    meta: { requiresAuth: true, permissions: ['ver_suscripciones'] }
  },

  // ---------------------------------------------------------------------
  // COBRANZA — una pantalla de caja, no un módulo (D23)
  //
  // Vive bajo Operación junto a caja, cierre y facturación. Cobrar SÍ es
  // del cajero; anular no (se gatea dentro de la pantalla).
  {
    path: '/cobranza',
    name: 'Cobranza',
    component: CobroView,
    meta: { requiresAuth: true, permissions: ['cobrar_deudas'] }
  },
  {
    path: '/cobranza/cobros',
    name: 'CobranzaCobros',
    component: CobrosView,
    meta: { requiresAuth: true, permissions: ['ver_cobros'] }
  },
  // `clienteId` opcional: sin él, la pantalla arranca en el
  // buscador; con él, muestra directo el estado de cuenta de esa persona.
  {
    path: '/cobranza/estado-cuenta/:clienteId?',
    name: 'CobranzaEstadoCuenta',
    component: EstadoCuentaView,
    meta: { requiresAuth: true, permissions: ['ver_estado_cuenta'] }
  },

  // Ventas cobradas con recibo, sin factura emitida (D33, D34). Vive en
  // Operación: es una pregunta de caja —qué falta facturar— y no
  // configuración del modelo de negocio.
  {
    path: '/cobranza/pendientes-facturar',
    name: 'VentasDiferidas',
    component: VentasDiferidasView,
    meta: { requiresAuth: true, permissions: ['ver_cobros'] }
  },

  // Compatibilidad con las rutas anteriores a la reagrupación (D23). Los
  // operadores que probaron el sistema tienen accesos guardados a
  // `/cobranza/suscripciones` y compañía; sin esto, un favorito lleva a una
  // pantalla en blanco y parece que el sistema se rompió. Se conserva el
  // mismo criterio que ya usan los redirects de `/mantenimiento/ecommerce`.
  { path: '/cobranza/suscripciones', redirect: { name: 'Suscripciones' } },
  { path: '/cobranza/suscripciones/nueva', redirect: { name: 'SuscripcionAlta' } },
  { path: '/cobranza/suscripciones/lote', redirect: { name: 'SuscripcionLote' } },
  {
    path: '/cobranza/suscripciones/:id',
    redirect: (to) => ({ name: 'SuscripcionDetalle', params: { id: to.params.id } })
  },
  { path: '/cobranza/esquemas', redirect: { name: 'Esquemas' } },
  {
    path: '/cobranza/esquemas/:id',
    redirect: (to) => ({ name: 'EsquemaDetalle', params: { id: to.params.id } })
  },
  { path: '/cobranza/generacion', redirect: { name: 'Generacion' } },
  { path: '/cobranza/cobrar', redirect: { name: 'Cobranza' } },

  {
    path: '/permisos',
    name: 'Permisos',
    component: PermisosView,
    meta: { requiresAuth: true, permissions: ['ver_permisos'] }
  },
  {
    path: '/inventario',
    component: InventoryLayout,
    children: [
      {path: '',             name: 'InvDashboard',    component: DashboardView, meta: { requiresAuth: true, permissions: ['gestionar_alertas'] } },
      {path: 'productos',    name: 'InvProductos',    component: ProductosView, meta: { requiresAuth: true, permissions: ['ver_productos'] } },
      {path: 'importacion-productos', name: 'InvImportacionProductos', component: ImportacionProductosView, meta: { requiresAuth: true, permissions: ['crear_productos'] } },
      {path: 'presentaciones', name: 'InvPresentaciones', component: PresentacionesView, meta: { requiresAuth: true, permissions: ['ver_productos'] } },
      {path: 'grupos-precio', name: 'InvGruposPrecio', component: GruposPrecioView, meta: { requiresAuth: true, permissions: ['ver_precio_venta'] } },
      {path: 'movimientos',  name: 'InvMovimientos',  component: MovimientosView, meta: { requiresAuth: true, permissions: ['ver_depositos'] } },
      {path: 'lotes',        name: 'InvLotes',        component: LotesView, meta: { requiresAuth: true, permissions: ['ver_depositos'] } },
      {path: 'control',      name: 'InvControl',      component: ControlInventarioView, meta: { requiresAuth: true, permissions: ['control_inventario_listar_control', 'control_inventario_cargar', 'control_inventario_generar'] } },
      {path: 'depositos',    name: 'InvDepositos',    component: DepositosView, meta: { requiresAuth: true, permissions: ['ver_depositos'] } },
      {path: 'mantenimiento', redirect: { name: 'MaintenanceOperational' } },
  {path: 'productos-precio', name: 'ProductosPrecio', component: ProductosPrecioView, meta: { requiresAuth: true, permissions: ['ver_precio_venta'] } },
  {path: 'categorias',   name: 'InvCategorias',   component: CategoriaView, meta: { requiresAuth: true, permissions: ['ver_categorias'] } }
  ,{path: 'unidades-medida', name: 'InvUnidadesMedida', component: UnidadMedidaView, meta: { requiresAuth: true, permissions: ['ver_unidad_medida'] } }
    ]
  },
  {
    // A-6 · SPEC_VISIBILIDAD_MODULOS_POR_ROL_v0.1.md 8.2
    //
    // Hasta acá ni el padre ni ocho de sus hijas declaraban `meta`, y el guard
    // sólo mira `to.meta.permissions`: **cualquier usuario autenticado que
    // tipeara la URL entraba a la pantalla**. La API sí las bloquea, así que no
    // hubo fuga de datos — la pantalla cargaba vacía o con error.
    //
    // El `meta` del padre lo heredan las hijas por el merge de Vue Router
    // (`mergeMetaFields` es un `Object.assign` en orden padre -> hija,
    // verificado contra la 4.4.5 instalada), así que una hija que declara el
    // suyo **restringe más**, nunca menos.
    path: '/mantenimiento',
    component: MaintenanceLayout,
    meta: {
      requiresAuth: true,
      permissions: [
        'ver_depositos', 'actualizar_deposito', 'ver_facturacion_electronica',
        'gestionar_facturacion_electronica', 'gestionar_jobs'
      ]
    },
    children: [
      { path: '', name: 'MaintenanceHome', component: MantenimientoHomeView },
      { path: 'operativo', name: 'MaintenanceOperational', component: MantenimientoOperativoView, meta: { requiresAuth: true, permissions: ['ver_depositos'] } },
      { path: 'balanzas', name: 'MaintenanceScales', component: MantenimientoBalanzasView, meta: { requiresAuth: true, permissions: ['ver_depositos'] } },
      { path: 'fiscal', name: 'MaintenanceFiscalDashboard', component: MantenimientoFiscalDashboardView, meta: { requiresAuth: true, permissions: ['ver_facturacion_electronica'] } },
      { path: 'fiscal/establishments', name: 'MaintenanceFiscalEstablishments', component: MantenimientoFiscalEstablecimientosView, meta: { requiresAuth: true, permissions: ['ver_facturacion_electronica'] } },
      { path: 'fiscal/points', name: 'MaintenanceFiscalPoints', component: MantenimientoFiscalPuntosView, meta: { requiresAuth: true, permissions: ['ver_facturacion_electronica'] } },
      { path: 'fiscal/timbrados', name: 'MaintenanceFiscalTimbrados', component: MantenimientoFiscalTimbradosView, meta: { requiresAuth: true, permissions: ['ver_facturacion_electronica'] } },
      { path: 'fiscal/series', name: 'MaintenanceFiscalSeries', component: MantenimientoFiscalSeriesView, meta: { requiresAuth: true, permissions: ['ver_facturacion_electronica'] } },
      { path: 'fiscal/facturacion', name: 'MaintenanceFiscalFacturacion', component: MantenimientoFiscalFacturacionView, meta: { requiresAuth: true, permissions: ['gestionar_facturacion_electronica'] } },
      { path: 'cajas', name: 'MaintenanceCashboxes', component: MantenimientoCajasView, meta: { requiresAuth: true, permissions: ['actualizar_deposito'] } },
      { path: 'jobs', name: 'MaintenanceJobs', component: MantenimientoJobsView, meta: { requiresAuth: true, permissions: ['gestionar_jobs'] } },
      // Redirects de compatibilidad (RF-2): estas dos rutas se mudaron a la
      // sección /ecommerce. Se conservan como redirect para no romper
      // accesos guardados ni enlaces que ya circulan entre los operadores.
      { path: 'ecommerce', redirect: { name: 'EcommerceConfiguracion' } },
      { path: 'imagenes', redirect: { name: 'EcommerceImagenes' } }
    ]
  },
  {
    path: '/ecommerce',
    component: EcommerceLayout,
    // Cualquiera de los dos permisos habilita la sección; el layout y el
    // Resumen filtran después qué ítems se ven con cada uno. Sin el meta,
    // un usuario sin ninguno de los dos llegaba igual al Resumen y veía una
    // pantalla vacía en vez de ser redirigido (detectado verificando
    // permisos en navegador real).
    meta: { requiresAuth: true, permissions: ['gestionar_ecommerce', 'editar_productos'] },
    children: [
      { path: '', name: 'EcommerceHome', component: EcommerceHomeView },
      { path: 'configuracion', name: 'EcommerceConfiguracion', component: EcommerceConfiguracionView, meta: { requiresAuth: true, permissions: ['gestionar_ecommerce'] } },
      { path: 'mensajes', name: 'EcommerceMensajes', component: EcommerceMensajesView, meta: { requiresAuth: true, permissions: ['gestionar_ecommerce'] } },
      { path: 'imagenes', name: 'EcommerceImagenes', component: EcommerceImagenesView, meta: { requiresAuth: true, permissions: ['editar_productos'] } }
    ]
  },
  {
    path: '/reportes',
    component: ReportesLayout,
    meta: { requiresAuth: true, permissions: ['ver_reportes'] },
    children: [
      { path: '', name: 'ReportesHome', component: ReportesHomeView },
      { path: 'ingresos', name: 'ReportesIngresos', component: ReportesIngresosView },
      { path: 'ventas', name: 'ReportesVentas', component: ReportesVentasView },
      { path: 'cierres-caja', name: 'ReportesCierresCaja', component: ReportesCierresCajaView },
      { path: 'productos-vendidos', name: 'ReportesProductosVendidos', component: ReportesProductosVendidosView },
      // D40, RN-81. «Cuentas por cobrar» ahora es la deuda de las cuotas; el
      // crédito de almacén conserva su reporte con su nombre real. **Sin
      // alias para la ruta vieja**: un alias sería el segundo camino que D40
      // vino a cerrar.
      { path: 'cuentas-por-cobrar', name: 'ReportesCuentasPorCobrar', component: ReportesMorosidadView },
      { path: 'creditos-clientes', name: 'ReportesCreditosClientes', component: ReportesCreditosClientesView },
      { path: 'cobranza-periodo', name: 'ReportesCobranzaPeriodo', component: ReportesCobranzaPeriodoView },
      { path: 'deuda-por-responsable', name: 'ReportesDeudaPorResponsable', component: ReportesDeudaPorResponsableView },
      { path: 'utilidad', name: 'ReportesUtilidad', component: ReportesUtilidadView },
      { path: 'compras-proveedor', name: 'ReportesComprasProveedor', component: ReportesComprasProveedorView }
    ]
  },
  {
    path: '/roles',
    name: 'Roles',
    component: RolesView,
    meta: { requiresAuth: true, permissions: ['ver_roles'] }
  },
  {
    path: '/cobro-cliente-credito',
    name: 'CobroClienteCredito',
    component: CobroClienteCredito,
    meta: { requiresAuth: true, permissions: ['cobrar_deuda'] }
  },
  {
    path: '/pago-factura',
    name: 'PagoFactura',
    component: PagoFactura,
    meta: { requiresAuth: true, permissions: ['ver_pagos_pendientes', 'pagar_compra'] }
  },
  {
    path: '/ingreso-varios',
    name: 'IngresoVarios',
    component: IngresoVariosView,
    meta: { requiresAuth: true, permissions: ['registrar_ingreso_vario'] }
  },
  {
    path: '/egreso-varios',
    name: 'EgresoVarios',
    component: EgresoVariosView,
    meta: { requiresAuth: true, permissions: ['registrar_egreso_vario'] }
  },
  {
    path: '/proveedores/editar/:id',
    name: 'EditarProveedor',
    component: RegistrarProveedor,
    props: true,
    meta: { requiresAuth: true, permissions: ['editar_proveedor'] }
  },
  // Redirect de compatibilidad: `/productos` apuntaba a la vista de precios,
  // pese a su nombre. Ahora lleva al módulo de productos, que es lo que
  // promete. Se conserva la ruta para no romper accesos guardados; el permiso
  // lo aplica la guarda del destino (`ver_productos`).
  {
    path: '/productos',
    name: 'Productos',
    redirect: { name: 'InvProductos' }
  },
  {
    path: '/registrar-producto',
    name: 'RegistrarProducto',
    component: RegistrarProductoModal,
    meta: { requiresAuth: true, permissions: ['crear_productos', 'editar_productos'] }
  },
  {
    // A-13 · No declaraba `meta` en absoluto: cualquier usuario autenticado
    // abría el terminal de venta. Y es, además, **el destino al que el guard
    // manda a quien rechaza** (ver `beforeEach`), así que el sistema respondía
    // «no podés entrar acá» dejando a la persona en la única ruta que no
    // comprobaba nada. `crear_venta` es lo que exige POST /api/sales, que es lo
    // que esta pantalla hace.
    path: '/pantalla-inicio',
    name: 'Inicio',
    component: PantallaInicio,
    meta: { requiresAuth: true, permissions: ['crear_venta', 'cobrar_venta'] }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: GerencialDashboardView,
    meta: { requiresAuth: true, permissions: ['ver_reportes'] }
  },
  {
    path: '/cobro-factura-venta',
    name: 'CobroFacturaVenta',
    component: CobroFacturaVentaView,
    meta: { requiresAuth: true, permissions: ['ver_cobros_pendientes', 'cobrar_venta'] }
  },
  {
    path: '/cobro-venta-rapida',
    name: 'CobroVentaRapida',
    component: CobroVentaRapidaView,
    meta: { requiresAuth: true, permissions: ['cobrar_venta'] }
  },
  {
    path: '/clientes',
    name: 'Clientes',
    component: ClientesView,
    meta: { requiresAuth: true, permissions: ['ver_cliente'] }
  },
  {
    path: '/clientes/creditos',
    name: 'ClientesCredito',
    component: ClientesCreditoView,
    meta: { requiresAuth: true, permissions: ['ver_credito'] }
  },
  {
    path: '/clientes/creditos/nuevo',
    name: 'ClienteCreditoCrear',
    component: ClienteCreditoCrearView,
    meta: { requiresAuth: true, permissions: ['crear_cliente_credito'] }
  },
  {
    path: '/clientes/:id/creditos/nuevo',
    name: 'ClienteCreditoAsignar',
    component: ClienteCreditoAsignarView,
    props: true,
    meta: { requiresAuth: true, permissions: ['crear_cliente_credito'] }
  },
  {
    path: '/clientes/creditos/:id',
    name: 'ClienteCreditoDetalle',
    component: ClienteCreditoDetalleView,
    props: true,
    meta: { requiresAuth: true, permissions: ['ver_credito'] }
  },
  {
    // Permitimos IDs alfanuméricos con guiones (ej: FAC-120-19999-4) para que el refresh (F5)
    // matchee correctamente. Antes estaba restringido a solo dígitos (\d+) y al recargar
    // /factura/FAC-120-19999-4 no encontraba coincidencia => pantalla en blanco.
    path: '/factura/:id([A-Za-z0-9-]+)',
    name: 'Factura',
    component: FacturaView,
    props: true,
    meta: { requiresAuth: true, permissions: ['ver_factura_compra'] }
  },
  {
    path: '/factura', // Ruta para registrar una nueva factura de compra
    name: 'RegistrarFactura',
    component: () => import('@/views/Factura.vue'), // Ruta al componente Factura
    props: route => ({
      datosParaFactura: route.query.datosParaFactura ? JSON.parse(decodeURIComponent(route.query.datosParaFactura)) : null,
    }),
    meta: { requiresAuth: true, permissions: ['crear_factura_compra'] }
  },
  {
    path: '/print/factura/:id',
    name: 'FacturaPrint',
    component: FacturaPrint,
    props: true,
    // Imprime una factura de COMPRA (`/api/purchases/invoices/:id`), así que
    // pide el mismo permiso que el listado del que sale. Era la única ruta
    // autenticada sin `permissions`: el guard global ya exigía token, pero
    // cualquier usuario logueado podía abrirla.
    meta: { requiresAuth: true, permissions: ['ver_factura_compra'] }
  },
  {
    path: '/nota-de-remision/:id',
    name: 'NotaDeRemision',
    component: NotaDeRemision,
    props: true,
    meta: { requiresAuth: true, permissions: ['ver_nota_remision'] }
  },
  {
    path: '/nota-de-remision', // Ruta para registrar una nueva nota de remisión
    name: 'RegistrarNotaDeRemision',
    component: NotaDeRemision,
    meta: { requiresAuth: true, permissions: ['crear_nota_remision'] }
  },
  {
    path: '/listar-comprobantes',
    name: 'ListarComprobantes',
    component: ListarComprobantes,
    meta: { requiresAuth: true, permissions: ['ver_factura_compra'] }
  },
  {
    path: '/gestion-pedidos',
    name: 'GestionPedidos',
    component: GestionPedidos,
    meta: { requiresAuth: true, permissions: ['ver_pedidos_pendientes'] }
  },
  {
    path: '/gestion-pedidos/e-pedidos',
    name: 'EPedidos',
    component: EPedidosView,
    meta: { requiresAuth: true, permissions: ['gestionar_ecommerce'] }
  },
  {
    path: '/ventas-facturas',
    name: 'VentasFacturas',
    component: VentasFacturasView,
    meta: { requiresAuth: true, permissions: ['ver_ventas'] }
  },
  {
    // SPEC_NOTAS_DE_CREDITO D44, RN-143. Era `/devoluciones`. **Sin alias** de
    // la ruta vieja: un alias es el segundo camino que el renombre vino a
    // cerrar (mismo criterio que D40). `permissions` es *any-of*.
    path: '/notas-credito',
    name: 'NotasCredito',
    component: NotasCreditoView,
    meta: { requiresAuth: true, permissions: ['ver_cobros', 'cobrar_venta'] }
  },
  {
    path: '/listar-notas-remision',
    name: 'ListarNotasDeRemision',
    component: ListarComprobantesNT,
    meta: { requiresAuth: true, permissions: ['ver_nota_remision'] }
  },
  {
    path: '/caja',
    name: 'Caja',
    component: CajaView,
    meta: { requiresAuth: true, permissions: ['abrir_caja', 'ver_caja'] }
  },
  {
    path: '/movimientos-caja',
    name: 'MovimientosCaja',
    component: MovimientosCajaView,
    meta: { requiresAuth: true, permissions: ['ver_caja'] }
  },
  {
    path: '/cerrar-caja',
    name: 'CerrarCaja',
    component: CerrarCajaView,
    meta: { requiresAuth: true, permissions: ['cerrar_caja'] }
  },
  {
    path: '/user-management',
    name: 'UserManagement',
    component: UserManagement,
    meta: { requiresAuth: true, permissions: ['ver_usuarios'] }
  },
  {
    path: '/listar-proveedores',
    name: 'ListarProveedores',
    component: ProveedoresView,
    meta: { requiresAuth: true, permissions: ['ver_proveedor'] }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const isPublicRoute = to.path === '/' || to.path === '/first-access';

  if (!isPublicRoute && !hasAuthToken()) {
    next({ path: '/' });
    return;
  }

  if (!isPublicRoute) {
    const assignedSucursales = getAssignedSucursales();
    if (!assignedSucursales.length) {
      next({ path: '/' });
      return;
    }
    const currentSucursalId = getCurrentSucursalIdFromSession();
    const currentAllowed = assignedSucursales.some((item) => Number(item?.sucursal_id) === Number(currentSucursalId));
    if (!currentAllowed) {
      const preferred = assignedSucursales.find((item) => item.predeterminada) || assignedSucursales[0];
      setCurrentSucursalId(preferred?.sucursal_id);
    }
  }

  if (to.meta?.permissions && !hasAnyPermission(to.meta.permissions)) {
    // A-8 · No se manda a un literal: se pregunta a `homeDestino`, que es la
    // misma función que usan el login y el logo. Mandar a `/pantalla-inicio`
    // dejó de ser seguro cuando esa ruta pasó a comprobar permisos (A-13):
    // el guard rechazaba, redirigía ahí, y ahí volvía a rechazar — bucle para
    // cinco de los ocho roles.
    next({ path: homeDestino(hasPermission) });
    return;
  }

  next();
});

// RN-176: un chunk que ya no existe suele significar que hubo un despliegue. Se
// consulta la versión y, si cambió, aparece el aviso. **Nunca se recarga sola**
// (RN-172).
router.onError((error) => {
  if (isChunkLoadError(error)) checkForUpdate();
});

export default router;
